import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams } from 'next/navigation';

import type { CommunityMember } from '@zealy/queries';
import { TaskCard, TaskCardHint } from '@zealy/design-system';
import { QuestionFilled } from '@zealy/icons';
import { useAuthenticatedUser, useCommunity } from '@zealy/queries';
import { roleIsAtLeast } from '@zealy/utils';

import { TelegramBrand } from '@zealy/icons';

import { TelegramLoginWidget } from '#app/cw/[subdomain]/settings/linked-accounts/_components/AccountSection/ConnectAccountButton/TelegramLoginWidget';
import { TASK_CONFIG } from '#constants/quests/Task.constants';

const ConnectTelegram = () => {
  const { subdomain } = useParams<{ subdomain: string }>();
  const { data: community } = useCommunity(subdomain);
  const user = useAuthenticatedUser<CommunityMember>();
  const t = useTranslations('settings.linked-accounts');

  const title = `${t('connect')} ${t('telegram.title')}`;

  const isAdmin = roleIsAtLeast(user?.data?.role, 'admin');
  const shouldShowHint = isAdmin && community?.requiredFields?.linkTelegram;

  return (
    <TaskCard
      title={title}
      type="telegram"
      className="px-200 py-300"
      icon={TASK_CONFIG.telegram.icon}
      hint={
        shouldShowHint && (
          <TaskCardHint
            icon={<QuestionFilled />}
            tooltip={t.rich('telegram.hint', {
              link: chunks => (
                <Link href={`/cw/${subdomain}/settings/security#access`} className="underline">
                  {chunks}
                </Link>
              ),
            })}
          >
            {t('telegram.hint-trigger')}
          </TaskCardHint>
        )
      }
    >
      <TelegramLoginWidget 
        buttonText={title}
        buttonProps={{
          size: "lg",
          className: "w-full text-white bg-task-type-telegram hover:bg-task-type-telegram-hover active:bg-task-type-telegram-press"
        }}
      />
    </TaskCard>
  );
};

export default ConnectTelegram;
